import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, ComponentRef,
  ElementRef, EventEmitter, HostBinding, Input, Inject, OnInit,
  OnDestroy, Output, Renderer2, ViewContainerRef, ViewChild, AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';




import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { Subscription ,  Observable, merge } from 'rxjs';

import { SegmentsParams } from 'shared/segments-navigation/segments-navigation/segments-navigation-params.interface';
import { itemWasUpdatedToast } from 'shared/toaster/toasts';
import { SegmentsNavigationComponent } from 'shared/segments-navigation/segments-navigation/segments-navigation.component';
import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';
import { PanelModalComponent } from 'shared/modal/panel-modal/panel-modal.component';
import { ConfirmBulkEditsModalComponent } from 'shared/modal/confirm-bulk-edits-modal/confirm-bulk-edits-modal.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';
import { PCDBModalComponent } from './components/pcdb-modal/pcdb-modal.component';
import { AppSummaryModalComponent } from './components/app-summary-modal/app-summary-modal.component';
import { SimpleConfirmModalComponent } from 'shared/modal/simple-confirm-modal/simple-confirm-modal.component';
import { ProcessingModalComponent } from 'shared/modal/processing-modal/processing-modal.component';

import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { BrandService } from 'shared/brand/brand.service';
import { DynamicComponentLoader } from 'shared/base/dynamic-component-loader.service';
import { HintsService } from 'shared/hints/hints.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { CommentsService } from 'shared/comments/comments.service';
import { QueueProcess } from 'shared/process/queue-process.model';
import { getRandomInt } from 'utils/utils';
import { ProcessService } from 'shared/process/process.service';

import { Config } from 'shared/config/env.config';
import { segments } from '../product-details/segments-list';
import { segmentRoutes } from './segment-routes';
import { ProductPanelService } from './product-panel.service';
import { rightPanelNavs } from './right-panel-navs';
import { ECOMMERCE_PANEL } from './product-panel-types';
import { indexPagesData } from 'utils/index-pages-data';
import { setUnreadCommentsCount } from 'shared/comments/comments-helpers';
import { ecommerceFields } from '../ecommerce/ecommerce-fields';
import { SearchModel } from 'shared/search/search.model';
import { finalize, first, takeWhile } from 'rxjs/operators';
import { CommentIconComponent } from 'shared/alerts/comment-icon/comment-icon.component';


@Component({
  moduleId: module.id,
  selector: 'product-panel-modal',
  templateUrl: 'product-panel.component.html',
  styleUrls: ['product-panel.component.scss'],
  providers: [SegmentValidationService, DynamicComponentLoader, HintsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPanelComponent implements OnDestroy, AfterViewInit {

  @HostBinding('class.bulk-edit-mode')

  @Input() bulkEdit: boolean = false;

  @Input() selectedIds: Array<any>;

  @Input() searchModel: SearchModel;

  @Input() listId: string;

  @Input() allSelected: boolean;

  @Input() totalRecords: number;

  // ['ecommerce']
  @Input() panelType: string;

  @Input() itemId: any;

  @Input() partNumber: any;

  @Input() description: string;

  @Input() updatedDate: string;

  @Input() showWarning: boolean = false;

  @ViewChild(SegmentsNavigationComponent, {static: false}) segmentsNavigation: SegmentsNavigationComponent;

  @ViewChild(PanelModalComponent, {static: false}) panelModal: PanelModalComponent;

  @ViewChild('pcdbModal', {static: false}) pcdbModal: PCDBModalComponent;

  @ViewChild('appSummaryModal', {static: false}) appSummaryModal: AppSummaryModalComponent;

  @ViewChild('confirmPartTypeChangeModal', {static: false})
  confirmPartTypeChangeModal: SimpleConfirmModalComponent;

  @ViewChild('segmentContainer', { read: ViewContainerRef, static: true }) segmentContainer: ViewContainerRef;

  @ViewChild('saveBeforeLeaving', {static: false}) saveBeforeLeaving: DefaultModalComponent;

  @ViewChild(ConfirmBulkEditsModalComponent, {static: false})
  confirmBulkEditsModal: ConfirmBulkEditsModalComponent;

  @ViewChild('segmentsContent', {static: false}) segmentsContent: ElementRef;

  @ViewChild(DynamicNavsComponent, {static: false}) dynamicNavs: DynamicNavsComponent;

  @Output() onModalHidden: EventEmitter<any> = new EventEmitter<any>();

  @Output() partTypeClick: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(ProcessingModalComponent, {static: false})
  processingModal: ProcessingModalComponent;

  @ViewChild(CommentIconComponent, {static: false})
  commentIcon: CommentIconComponent | void;

  uiModel: any = {};
  model: any = {};
  segmentsNavigationData: SegmentsParams = {
    segments: [],
    sideNavSize: 100,
    marginLeft: 0,
    rightPaginationWidth: 100,
  };
  activeQueueProcesses: Array<QueueProcess> = [];
  isPageActive: boolean = true;
  rightPanelNavs: any[] = rightPanelNavs;
  componentRef: ComponentRef<any>;
  noCache: string = '';
  itemDetailFetchSub: Subscription;
  saving: boolean = false;
  status: string; // itemDetail status id (draft, published, approved, etc)
  private pcdbData: any = {
    selectedPartType: null,
    partTerminology: null,
  };

  get isModalShown() {
    return this.productPanelService.uiModel.isModalShown.getValue();
  }

  get isDirty(): boolean {
    if (this.componentRef && this.componentRef.instance) {
      return this.componentRef.instance.isDirty;
    } else {
      return false;
    }
  }

  get bulkSecondaryTitle(): string {
    return this.allSelected ?
      `About ${this.totalRecords} Products selected`
      : `${this.selectedIds.length} Products selected`;
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get bulkEditCount(): number {
    if (this.allSelected) {
      return this.totalRecords;
    } else {
      return this.selectedIds.length;
    }
  }

  get segmentName(): string {
    return this.model.segment;
  }

  constructor(
    private productPanelService: ProductPanelService,
    protected router: Router,
    private route: ActivatedRoute,
    private dynamicComponentLoader: DynamicComponentLoader,
    private toastrService: ToastrService,
    private brandService: BrandService,
    private permissionsService: PermissionsService,
    private segmentValidationService: SegmentValidationService,
    private commentsService: CommentsService,
    private ref: ChangeDetectorRef,
    protected processService: ProcessService,
  ) {}

  ngAfterViewInit() {
    this.uiModel = this.productPanelService.uiModel;
    this.model = this.productPanelService.model;
    this.noCache = Date.now().toString();
    this.panelModal.onShown
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe(() => {
      this.productPanelService.setIsModalShown(true);
      _.delay(() => {
        this.segmentsNavigation.setActive(this.model.segment);
        this.ref.markForCheck();
      }, 200);
      if (this.bulkEdit) { this.updateRightNavs(); }
    });
    this.panelModal.onHidden
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe(() => {
      this.productPanelService.setIsModalShown(false);
      this.onModalHidden.emit(true);
      if (this.itemDetailFetchSub) { this.itemDetailFetchSub.unsubscribe(); }
      this.dynamicNavs.selectNav('hints');
      this.destroySegment();
      this.ref.markForCheck();
    });
    this.subscribeNavsChange();
  }

  ngOnDestroy() {
    this.isPageActive = false;
    this.model = {};
    this.uiModel = {};
    this.segmentsNavigationData.segments = [];
    this.segmentValidationService.resetValidation();
    if (this.itemDetailFetchSub) { this.itemDetailFetchSub.unsubscribe(); }
    this.destroySegment();
    this.productPanelService.setIsModalShown(false);
  }

  // handlers
  onSelectSegment(segment: any) {
    if (this.isDirty) {
      this.saveBeforeLeaving.show();
      this.model.nextSegment = segment.name;
    } else {
      if (segment.name === 'fitments') {
        this.navigateToFitments();
      } else {
        this.renderSegment(this.findSegment(segment.name));
      }
    }
  }

  onSaveClick() {
    // this.toastrService.info('', '', itemWasUpdatedToast({
    //   name: 'Richard Cypher',
    //   img: '/image/',
    //   time: 'Just now',
    // }));
    if (this.bulkEdit) {
      this.confirmBulkEditsModal.show();
    } else {
      this.saveComponentChanges();
    }
  }

  onCancelClick() {
    if (this.isDirty) {
      this.componentRef.instance.cancel();
    } else {
      this.hide();
    }
  }

  onSaveBeforeLeaving(action: string) {
    switch (action) {
      case 'save':
        this.componentRef.instance.save().subscribe(() => {
          if (this.componentRef.instance.onSaved) {
            this.componentRef.instance.onSaved();
          }
        });
        break;
      case 'cancel':
        this.segmentsNavigation.setActive(this.model.segment);
        return this.saveBeforeLeaving.hide();
    }
    this.saveBeforeLeaving.hide();
    if (this.model.nextSegment === 'fitments') {
      this.navigateToFitments();
    } else {
      this.renderSegment(this.findSegment(this.model.nextSegment));
    }
  }

  onConfirmBulkEdits() {
    this.saveComponentChanges();
    this.confirmBulkEditsModal.hide();
  }

  onPCDBModalHidden() {
    console.log('PCDB Modal was hidden');
  }

  onAppSummaryModalHidden() {
    console.log('App Summary Modal was hidden');
  }

    /*******************************************
  * APP SUMMARY MODAL HANDLERS
  *******************************************/
  /*
   * Show the App Summary Modal
  appSummaryShow() {

    let appSummary = {
      template_id: 0,
      custom_value: ''
    };

    if (!this.bulkEdit) {
      const appSummaryTemplateId = this.appSummaryData.appSummary.template_id;
      const customValue = this.appSummaryData.appSummary.custom_value;
      appSummary = {
        template_id: appSummaryTemplateId,
        custom_value: customValue
      };
    }
    console.log('sending appSummar', appSummary);
    this.appSummaryData.appSummary = appSummary;
    this.appSummaryModal.show(appSummary, this.bulkEdit);
  }
   */

  onAppSummaryClick(data: any) {
    console.log('onAppSummaryClick');
      /*
    const {partTerminology, bulkEdit} = data;
    this.pcdbData.partTerminology = partTerminology;
    this.pcdbModal.show(partTerminology, bulkEdit);
    */
  }

  onPartTypeClick(data: any) {
      console.log('onPartTypeClick');
    const {partTerminology, bulkEdit} = data;
    this.pcdbData.partTerminology = partTerminology;
    this.pcdbModal.show(partTerminology, bulkEdit);
  }

  onSelectPartType(partType: any) {
    this.pcdbData.selectedPartType = partType;
    _.delay(() => {
      this.confirmPartTypeChangeModal.show();
    }, 200);
  }

  onPartTypeChangeConfirm() {
    this.componentRef.instance.updatePartType(this.pcdbData.selectedPartType);
    this.pcdbData.selectedPartType = null;
    this.pcdbData.partTerminology = null;
  }

  onPartTypeChangeCancel() {
    this.pcdbModal.show(this.pcdbData.partTerminology, this.bulkEdit);
    this.pcdbData.selectedPartType = null;
    this.pcdbData.partTerminology = null;
  }

  onForceSave(event: any) {
    this.saveComponentChanges(event);
  }

  onForceCancel() {
    this.saving = false;
    this.componentRef.instance.cancel();
  }

    detectQueueProcessProgress(queueProcess: QueueProcess): void {
    _.delay(() => {
      console.log(queueProcess);
      this.processService.getQueueProcess(this.brandService.getBrand(), queueProcess.id)
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((process: any) => {
        if (!this.isPageActive) { return; }
        queueProcess.progress = process.progress;
        this.ref.markForCheck();
        if (process.progress < 100) {
          this.detectQueueProcessProgress(queueProcess);
        } else {
          _.pull(this.activeQueueProcesses, queueProcess);
          if (!_.size(this.activeQueueProcesses)) {
            this.processingModal.hide();
            this.handleCompleteQueueProcess(queueProcess);
          }
        }
      });
    }, getRandomInt(500, 2500));
  }

  handleCompleteQueueProcess(queueProcess: QueueProcess): void {
    this.subscribeToItemDetailFetchEvent();
    this.componentRef.instance.subscribeToItemDetail();
    this.componentRef.instance.markAsPristine();
    this.noCache = Date.now().toString();
    this.ref.markForCheck();
    this.hide();
  }

  // public
  public show(segmentName: string) {
    this.setNavigationSegments();
    this.panelModal.show();
    localStorage.removeItem('bulkDetailsData');
    this.renderSegment(this.findSegment(segmentName));
    this.subscribeToItemDetailFetchEvent();
  }

  public hide() {
    this.unsubscribeSegment();
    this.panelModal.hide();
  }

  getProductThumbnail(): string {
    const { id } = this.route.snapshot.params;
    let thumbnail: string = Config.DEFAULT_PRODUCT_IMAGE;
    if (id) {
      thumbnail = `${Config.BACKEND}parts/assets/item/${id}/100?noCache=${this.noCache}`;
    }
    return thumbnail;
  }

  public toggle(toggle: boolean, segment?: string, data?: any) {
    if (toggle) {
      if (data) {
        this.model.data = data;
      }
      this.show(segment);
    } else {
      this.hide();
    }
  }

  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  // private
  private renderSegment(segment: any): void {
    if (this.itemDetailFetchSub) { this.itemDetailFetchSub.unsubscribe(); }
    this.unsubscribeSegment();
    this.componentRef = null;
    this.componentRef = this.dynamicComponentLoader.load(
      segment.component,
      this.segmentContainer,
      {
        bulkEdit: this.bulkEdit,
        selectedIds: this.selectedIds,
        searchModel: this.searchModel,
        listId: this.listId,
        allSelected: this.allSelected,
        panelType: this.panelType,
      }
    );
    if (segment.path === 'item-details') {
      this.componentRef.instance.partTypeClick.subscribe(this.onPartTypeClick.bind(this));
      this.componentRef.instance.forceSave.subscribe(this.onSaveClick.bind(this));
    }
    if (segment.path === 'digital-assets') {
      this.componentRef.instance.forceSave.subscribe(this.onForceSave.bind(this));
      this.componentRef.instance.forceCancel.subscribe(this.onForceCancel.bind(this));
    }
    this.model.segment = segment.path;
    this.panelModal.scrollContentTop();
  }

  private destroySegment(): void {
    this.dynamicComponentLoader.destroy();
    this.componentRef = null;
  }

  private findSegment(name: string) {
    return segmentRoutes.find((item: any) => item.path === name);
  }

  private saveComponentChanges(props?: any) {
    this.saving = true;
    const obs = this.componentRef.instance.save(props);
    if (obs) {
      obs.pipe(
        first(),
        finalize(() => {
          this.saving = false;
          this.ref.markForCheck();
        })
      )
      .subscribe((response) => {
        if (!response.processId) {
            this.subscribeToItemDetailFetchEvent();
            this.componentRef.instance.subscribeToItemDetail();
            this.componentRef.instance.markAsPristine();
            this.noCache = Date.now().toString();
            this.ref.markForCheck();
        } else {
          const process: QueueProcess = new QueueProcess(response.processId, 0);
          this.activeQueueProcesses.push(process);
          if (this.commentIcon) {
            this.commentIcon.showAndHide();
          }
          this.detectQueueProcessProgress(process);
        }
      });
    }
  }

  private unsubscribeSegment(): void {
    if (_.has(this, 'componentRef.instance.partTypeClick')) {
      this.componentRef.instance.partTypeClick.unsubscribe(this.onPartTypeClick);
    }
    if (_.has(this, 'componentRef.instance.forceSave')) {
      this.componentRef.instance.forceSave.unsubscribe(this.onForceSave);
    }
    if (_.has(this, 'componentRef.instance.forceCancel')) {
      this.componentRef.instance.forceCancel.unsubscribe(this.onForceCancel);
    }
  }

  private setNavigationSegments() {
    if (this.bulkEdit) {
      // remove validation marks in the bulkEdit mode
      this.segmentsNavigationData.segments = _.map(segments, (item: any) => {
        item.circleIcon = false;
        return item;
      });
      this.segmentsNavigationData.segments = _.filter(this.segmentsNavigationData.segments, (item: any) => {
        return item.segment !== 'marketing' && item.segment !== 'fitments';
      });
    } else {
      this.segmentsNavigationData.segments = (this.panelType === ECOMMERCE_PANEL)
      ? _.filter(segments, (item: any) => {
          return item.segment !== 'kits' && item.segment !== 'interchanges' && item.segment !== 'marketing';
        })
      : this.segmentsNavigationData.segments = _.filter(segments, (item: any) => {
        return item.segment !== 'marketing';
      });
    }

    // remove 'fitments' segment if no permission
    if (!this.hasPermission(['admin', 'fitments'])) {
      this.segmentsNavigationData.segments = _.filter(this.segmentsNavigationData.segments, (item: any) => {
        return item.segment !== 'fitments';
      });
    }
  }

  private navigateToFitments() {
    const { id } = this.route.snapshot.params;
    this.router.navigate([`/fitments/${id}`]);
  }

  private subscribeToItemDetailFetchEvent(): void {
    if (this.itemDetailFetchSub) { this.itemDetailFetchSub.unsubscribe(); }
    this.itemDetailFetchSub = this.componentRef.instance.itemDetailFetched
    .pipe(takeWhile(() => !!this.componentRef))
    .subscribe((itemDetail: any) => {
      this.partNumber = _.get(itemDetail, 'partNumber');
      this.status = _.get(itemDetail, 'status');
      this.setUnreadCommentsCount();
      this.updateRightNavs();
      this.updateSegmentsValidation(itemDetail);
    });
  }

  private subscribeNavsChange(): void {
    this.dynamicNavs.changeNav
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((obj: any) => {
      if (obj.nav.name === 'comments') {
        obj.componentRef.instance.fetch(this.brandId, this.partNumber, 'item');
        merge(
          obj.componentRef.instance.commentMarkedAsRead,
          obj.componentRef.instance.commentResolved
        )
          .pipe(takeWhile(() => obj.componentRef.instance.isActive))
          .subscribe(() => {
            this.setUnreadCommentsCount();
          });
      }
    });
  }

  private updateRightNavs(): void {
    const allowedStatuses = [
      ...indexPagesData.published.itemStatuses,
      ...indexPagesData.working.itemStatuses,
    ];
    if (this.bulkEdit || !_.includes(allowedStatuses, this.status)) {
      // Comments are disabled in the bulk edit state
      // Comments are allowed for working and published items only
      this.rightPanelNavs = _.filter(rightPanelNavs, (item: any) => {
        return item.name !== 'comments';
      });
    } else {
      this.rightPanelNavs = rightPanelNavs;
    }
  }

  private setUnreadCommentsCount(): void {
    this.commentsService.getUnreadCount(this.brandId, 'item', this.partNumber)
    .subscribe((data: any) => {
      setUnreadCommentsCount(this.rightPanelNavs, data.count);
      this.ref.markForCheck();
    });
  }

  private updateSegmentsValidation(itemDetail: any): void {
    if (this.panelType === ECOMMERCE_PANEL) {
      // filter errors which related to ecommerce page only
      const ecommErrors = _.filter(_.get(itemDetail, 'validation.combinedErrors'), (error: any) => {
        return _.some(ecommerceFields, (item: any) => {
          return error.indexOf(item) !== -1;
        });
      });
      this.showWarning = ecommErrors.length > 0;
      this.segmentsNavigation.toggleCircles((segmentItem: any) => {
        return _.some(ecommErrors, (item: any) => {
          return item.indexOf(segmentItem.segment) !== -1;
        });
      });
    } else {
      this.segmentsNavigation.toggleCircles((segment: any) => {
        return itemDetail.validation.segmentErrors.indexOf(segment.segment) > -1;
      });
    }
  }
}
